import { state } from './stores.js';
import { get } from 'svelte/store';

function listNames(cards){
    return cards.map(c => c.name).join(', ')
}

export async function copySetup(){
    let text = 
`[b]Your captain:[/b] ${get(state).players[0].captain}
[b]Bot captain:[/b] ${get(state).players[1].captain}

[b]Your starting hand:[/b] ${listNames(get(state).players[0].decks.hand)}
[b]Your reserve (top to bottom):[/b] ${listNames(get(state).players[0].decks.reserve)}

[b]Encounter deck:[/b] ${listNames(get(state).commons.encounters)}
[b]Person market/deck:[/b] ${listNames(get(state).commons.people.slice(0, 3))}
[b]Cargo market/deck:[/b] ${listNames(get(state).commons.cargo.slice(0, 3))}
[b]Ship market/deck:[/b] ${listNames(get(state).commons.ships.slice(0, 3))}
[b]Ally market/deck:[/b] ${listNames(get(state).commons.allies.slice(0, 3))}
[b]Neutral Zone:[/b] ${listNames(get(state).commons.neutral_zone)}
[b]Location deck:[/b] ${listNames(get(state).commons.locations.slice(0, 3))}

[b]Top 5 cards of Bot deck:[/b] ${listNames(get(state).players[1].decks.deck.slice(0, 5))}
`
await navigator.clipboard.writeText(text);
alert('Text copied to clipboard!')
}